import React from 'react';
import './index.scss';
// eslint-disable-next-line no-unused-vars

const EditModuleTitle = ({ title }: { title: string }) => {
  return (
    <div className='module_title'>
      <div >{title}</div>
    </div>
  )
}
export default React.memo(EditModuleTitle);